import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

type SignupSourcesType = {
  referrer: string | null;
  utm_source: string | null;
  utm_medium: string | null;
  utm_campaign: string | null;
  gclid__c: string | null;
};

export interface SubscribeState {
  subscribeEmail: string;
  subscribeModalOpen?: boolean;
  marketing: boolean;
  fund: boolean;
  brokerage: boolean;
  signupSources?: SignupSourcesType | null;
}

const initialState: SubscribeState = {
  subscribeEmail: "",
  subscribeModalOpen: false,
  marketing: true,
  fund: true,
  brokerage: true,
  signupSources: null,
};

export type SubscribeGroupType = "fund" | "marketing" | "brokerage";

const SubscribeSlice = createSlice({
  name: "subscribe",
  initialState: initialState,
  reducers: {
    setSubscribeModalOpen: (state: SubscribeState, action: PayloadAction<boolean>): void => {
      state.subscribeModalOpen = action.payload;
    },
    setSubscribeEmail: (state: SubscribeState, action: PayloadAction<string>): void => {
      state.subscribeEmail = action.payload;
    },
    setSubscribeGroups: (
      state: SubscribeState,
      action: PayloadAction<"fund" | "marketing" | "brokerage">,
    ): void => {
      state[action.payload] = !state[action.payload];
    },
    // reset subscribe groups
    resetSubscribeGroups: (state: SubscribeState): void => {
      state.marketing = true;
      state.fund = true;
      state.brokerage = true;
    },
    setSignupSources: (state: SubscribeState, action: PayloadAction<SignupSourcesType>): void => {
      state.signupSources = action.payload;
    },
  },
});

export const {
  setSubscribeModalOpen,
  setSubscribeEmail,
  setSubscribeGroups,
  resetSubscribeGroups,
  setSignupSources,
} = SubscribeSlice.actions;

// Use useSelector directly to avoid circular dependency with store.ts
export const useSubscribeState = () =>
  useSelector((state: { subscribe: SubscribeState }) => state.subscribe);

type listNamesType = SubscribeGroupType[];

export const useGetSubscribedGroups = (): listNamesType => {
  const state = useSubscribeState();
  let groups: listNamesType = [];
  if (state.marketing) groups.push("marketing");
  if (state.fund) groups.push("fund");
  if (state.brokerage) groups.push("brokerage");
  return groups;
};

export default SubscribeSlice;
